import axios from '@/axios';

const INDUSTRY_PREFIX = '/api/screen-config/industry';

export const getIndustryDetail = (id) => {
  if (!id && id !== 0) {
    return Promise.reject(new Error('industry id is required'));
  }
  return axios.post(`${INDUSTRY_PREFIX}/detail/${id}`);
};

export const editIndustry = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return Promise.reject(new Error('payload is required'));
  }
  return axios.post(`${INDUSTRY_PREFIX}/edit`, payload);
};

// 介绍
export const getIndustryIntroduction = () => {
  return axios.post(`${INDUSTRY_PREFIX}/default-industry`);
};
